import { View, VStack } from "@gluestack-ui/themed";
import { MenuActionsList } from "@repo/core/components/layout/MenuActionsList";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { ReportsController } from "./controller";
import { StatusBar } from "@repo/core/components/layout/StatusBar";
import { ScrollView } from "@repo/core/components/layout/ScrollView";
import { Text } from "@repo/core/components/core/Text";
import { StoreSelector } from "../Sales/components/StoreSelector";
import { StoreSelectorVariantEnum } from "../Sales/components/StoreSelector/types";
import { Button } from "@repo/core/components/core/Button";
import { MustShow } from "@repo/core/components/core/MustShow";

const Reports = () => {
  const {
    isMobile,
    reportsMenuSections,
    modalRef,
    handleOnSelectStore,
    selectedStore
  } = ReportsController();
  return (
    <Scaffolds.StoreSelect
      showHeader={false}
      overrideModalRef={modalRef}
      showSelectStoreBar={false}
      storeSelectorVariant={StoreSelectorVariantEnum.SHOPKEEPER}
    >
      <StatusBar barStyle="light-content" showCustomStatusBar />
      <ScrollView bgColor="$backgroundLight50">
        <View flex={1} alignItems="center" bg="$backgroundLight50">
          <VStack
            p="$4"
            space="lg"
            bg="$primary700"
            alignItems="center"
            w="$full"
            h={100}
          >
            <Text
              color="$textLight50"
              fontSize="$lg"
              family="inter"
              fontWeight={500}
            >
              Relatórios
            </Text>
            <StoreSelector
              selectedStore={selectedStore}
              onSelectStore={handleOnSelectStore}
              enableSelectStore
              variant={StoreSelectorVariantEnum.SHOPKEEPER}
            />
          </VStack>
          <VStack
            flex={1}
            p="$4"
            gap="$3"
            $web-lg-w="52%"
            $web-md-w="80%"
            $sm-w="$full"
            $base-w="$full"
          >
            {reportsMenuSections.map((reportMenuSection) => (
              <MenuActionsList
                titleStyles={{ fontSize: "$xs", color: "$textLight600" }}
                width="100%"
                gap="$2"
                {...reportMenuSection}
              />
            ))}

            <MustShow isVisible={!isMobile}>
              <VStack
                mt="$4"
                mb="$16"
                p="$4"
                gap="$4"
                borderWidth="$2"
                borderColor="$borderLight200"
                borderRadius="$lg"
                bg="$backgroundDark0"
              >
                <VStack gap="$1">
                  <Text color="$textLight900" fontWeight={500}>
                    Relatórios adicionais
                  </Text>
                  <Text color="$textLight800" fontSize="$sm">
                    Você pode acessar mais relatórios sobre o resultado da sua
                    loja no link abaixo
                  </Text>
                </VStack>
                <Button
                  onPress={() => {
                    if (typeof window !== "undefined") {
                      window.open(
                        "https://atendimento.wayupbrasil.com/Login",
                        "_blank"
                      );
                    } else {
                      // Fallback for React Native
                      import("expo-linking").then(({ openURL }) => {
                        openURL("https://atendimento.wayupbrasil.com/Login");
                      });
                    }
                  }}
                  text="Ver mais relatórios"
                  leftIcon={{
                    name: "arrow-up-right-from-square",
                    size: 20,
                    color: "$white"
                  }}
                />
              </VStack>
            </MustShow>
          </VStack>
        </View>
      </ScrollView>
    </Scaffolds.StoreSelect>
  );
};

export default Reports;
